export type ApiPageInitRequest = void;

export type TotalUsage = {
    /**
         * 已使用次数
         */
    usage: number;
    /**
     * 总数
     */
    total: number;
};

export type ApiPageInitResponse = {
    /**
     * 新颖性搜索次数限制
     */
    novelty_search_usage: TotalUsage;
    /**
     * 侵权搜索次数限制
     */
    fto_search_usage: TotalUsage;
    /**
     * 说明书次数限制
     */
    specification_usage: TotalUsage;
    /**
     * 交底书次数限制
     */
    patent_disclosure_usage: TotalUsage;
    /**
     * 翻译次数限制
     */
    translation_usage: TotalUsage;
    /**
     * 中文说明书次数限制
     */
    cn_patent_specification_usage: TotalUsage;
    /**
     * 英文说明书次数限制
     */
    us_patent_specification_usage: TotalUsage;
    /**
     * 欧洲说明书次数限制
     */
    eu_patent_specification_usage: TotalUsage;
    unified_patent_specification_usage: TotalUsage;
    unified_usage: TotalUsage;
    unified_pro_usage: TotalUsage;
    unified_free_usage: TotalUsage;
    tier_code: 'FREE' | 'PRO' | 'ENTERPRISE';
    /**
     * 权限信息
     */
    permission: {
        /**
         * 是否有 AI 翻译权限
         */
        ai_translation: boolean;
        /**
         * 是否具有交底书权限
         */
        ai_disclosure: boolean;
        /**
         * 是否具有中文说明书权限
         */
        ai_specification_cn: boolean;
        /**
         * 是否具有英文说明书权限
         */
        ai_specification_us: boolean;
        /**
         * 是否具有欧洲说明书权限
         */
        ai_specification_eu: boolean;
        /**
         * 新颖性搜索
         */
        ai_novelty_search: boolean;
        /**
         * 侵权搜索
         */
        ai_fto_search: boolean;
        /**
         * 图像检索
         */
        ai_image_search: boolean;
    };
    /**
     * 时区信息
     */
    time_zone: {
        /**
         * 时区偏移量
         * @description 单位：分钟
         * @example 480（东八区）
         */
        utc_offset: number;
        /**
         * 时区文字标识
         * @example "Asia/Shanghai"
         */
        value: string;
    };
    /**
        * 是否有保存到工作空间的权限
        */
    workspace_permission: boolean;
};

export const PageInit = Symbol.for('PageInit');

export interface PageInit {
    pageInit(data: ApiPageInitRequest): Promise<ApiPageInitResponse>;
}
